var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17 1h14.764l.006.001v.006l.001.163v20.44c0 .152 0 .248-.002.317v.024l-.02-.014c-.056-.041-.131-.1-.252-.193l-5.865-4.557-.021-.016c-.076-.06-.17-.132-.268-.192a2 2 0 0 0-2.085 0 5.445 5.445 0 0 0-.289.209l-5.865 4.556a14 14 0 0 1-.271.207l-.001-.024C1 21.857 1 21.762 1 21.61V1.006l.001-.006h.006z"
  })));
};
export default SvgBookmark;